var CRcarrierServiceEnabled = true; 

document.addEventListener('crJQActivated', function (e) {
    // reset when rates are enabled //
    storePickup.getCartItems().then(function(response) {
    if(typeof CRcarrierServiceEnabled !== "undefined" && CRcarrierServiceEnabled === true && response.items.length) {
        console.log('Add line property #2')
        storePickup.addLineProperty(response, 'shipping');      
    }
    })
    // ** //  
})
